import { isKnowledgeObject } from "@/lib/public-knowledge-template";

const SLUG_RE = /^[a-z0-9][a-z0-9-]{0,80}$/;
function safeSlug(value: string | null): string | undefined {
  return value && SLUG_RE.test(value) ? value : undefined;
}
export interface HelpContactView {
  articleSlug?: string;
  topicSlug?: string;
  surface: string;
}
export function buildHelpContactView(search: string): HelpContactView {
  const params = new URLSearchParams(search);
  return {
    articleSlug: safeSlug(params.get("article")), topicSlug: safeSlug(params.get("topic")),
    surface: params.get("surface") || "contact_page_direct",
  };
}
export function isHelpContactView(value: unknown): value is HelpContactView {
  return isKnowledgeObject(value) && typeof value.surface === "string" &&
    (value.articleSlug === undefined || typeof value.articleSlug === "string" && SLUG_RE.test(value.articleSlug)) &&
    (value.topicSlug === undefined || typeof value.topicSlug === "string" && SLUG_RE.test(value.topicSlug));
}
